module.exports = __webpack_public_path__ + "static/ainbr_og-1f6fa2cee9db3fdc08e8713d8435c904.png";